import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal.component';
import { WmTransitionModule } from '../transition/index';
import { WmIconModule } from '../icon/index';
import { WmButtonModule } from '../button/index';
import { WmCardModule } from '../card/index';

@NgModule({
	declarations: [ModalComponent],
	imports: [CommonModule, WmTransitionModule, WmIconModule, WmButtonModule, WmCardModule],
	exports: [ModalComponent]
})
export class WmModalModule {}
